<template>
  <NavButton
    v-if="enable"
    :label="label"
    btn-id="download-button"
    icon="file-download"
    :image-src="imageSrc"
    :list="list"
    @click="download"
  />
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import NavButton from '@/components/public/NavButtons/NavButton.vue'

import { getDataDownload } from '@/api'
import {
  DOWNLOAD_CONFIG_KEY,
  DOWNLOAD_FIELDS_KEY,
} from '@/constants'

const components = {
  NavButton,
}

const props = {
  list: Boolean,
}

@Component({ components })
export default class NavBtnDownload extends Vue.extend({ props }) {
  get enable () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.download.enabled
  }

  get label () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.download.buttonName
  }

  get fields () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.download.fields
  }

  get imageSrc () {
    return this.$typedStore.activeVisualisation.visualisationStore.entities.images.imageOrPreview(['config', DOWNLOAD_CONFIG_KEY, 'buttonIcon'])
  }

  async download () {
    // https://blog.logrocket.com/programmatic-file-downloads-in-the-browser-9a5186298d5c/
    if (this.fields.length === 0) {
      return this.$bvModal.msgBoxOk('No fields have been selected for download.')
    }
    const blob = await getDataDownload({ [DOWNLOAD_FIELDS_KEY]: this.fields }, this.$typedStore.activeVisualisation.visualisationAppRank)
    if ('msSaveOrOpenBlob' in navigator) {
      (window.navigator as any).msSaveOrOpenBlob(blob, 'download.csv')
      return
    }
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = 'download.csv'
    a.click()
    URL.revokeObjectURL(url)
  }
}

</script>
